import './styles.scss';

import { Icon, Link } from '@ets-global/b2c-website-ui';
import { string } from 'prop-types';
import React from 'react';

import { GoogleStaticMap } from '../Google';

const LocationLoader = ({ centerName, address, website, email, phone }) => {
  return (
    <div className="location-center">
      <div className="location-center__column">
        <h2 className="location-center__name">{centerName}</h2>
        <ul className="location-center__informations">
          <li className="location-center__information-item">
            <Icon name={'marker'} aria-label="marker-icon" role="img" />
            <span className="location-center__information-item-text">{address}</span>
          </li>
          {website && (
            <li className="location-center__information-item">
              <Icon name={'www'} aria-label="www-icon" role="img" />
              <span className="location-center__information-item-text">
                <Link to={website} target={'_blank'} aria-label={`link to ${website}`}>
                  {website}
                </Link>
              </span>
            </li>
          )}
          {email && (
            <li className="location-center__information-item">
              <Icon name={'arobase'} aria-label="arobase-icon" role="img" />
              <span className="location-center__information-item-text">
                <Link to={`mailto:${email}`} target={'_blank'} aria-label={`send email to ${email}`}>
                  {email}
                </Link>
              </span>
            </li>
          )}
          {phone && (
            <li className="location-center__information-item">
              <Icon name={'phone'} aria-label="phone-icon" role="img" />
              <span className="location-center__information-item-text">
                <Link to={`tel:${phone}`} target={'_blank'} aria-label={`call ${phone}`}>
                  {phone}
                </Link>
              </span>
            </li>
          )}
        </ul>
      </div>

      {address && (
        <div className="location-center__column">
          <GoogleStaticMap
            className="location-center__map"
            zoom={18}
            address={address}
            size={{ width: 905, height: 487 }}
            link={true}
          />
        </div>
      )}
    </div>
  );
};

LocationLoader.propTypes = {
  centerName: string.isRequired,
  address: string.isRequired,
  website: string,
  email: string,
  phone: string,
};

export default LocationLoader;
